/*
 * File: FeedActionDropdown.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on February 7, 2022 at 1:53 PM
 * Copyright © 2022 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 28, 2025 at 10:36 AM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled, { css } from 'styled-components';


/**
 * Styles
 */

export const Wrapper = styled.div`
	position: relative;
`;

export const ActionButton = styled.button`
	display: flex;
	gap: 5px;
	align-items: center;
	border: none;
	background-color: transparent;
	cursor: pointer;
	padding: 0px 10px;
    height: 32px;
	border-radius: 20px;

	&:hover {
		background-color: ${({ theme }) => theme.neutralButton};
	}
	* {
		color: ${({ theme }) => theme.secondaryText};
	}
	svg {
		font-size: 0.84rem;

		${({ $isOpen }) => $isOpen && css`
			transform: rotate(180deg);
		`}
	}
`;

export const DropdownWidget = styled.div`
	position: absolute;
	height: auto !important;
	z-index: 100;
	background-color: ${({ theme }) => theme.surfaceBackground};
	border-radius: 8px;
	overflow: hidden;
	left: 0px;
	box-shadow: ${({ theme }) => theme.surfaceShadow};
	top: 36px;
	${({ theme }) => theme.navigationBorder !== 'transparent' && css`
		border: 1px solid ${theme.navigationBorder};
	`}
	opacity: 0;
	visibility: hidden;
	transform: scale(1.05);
	transition: visibility 0s linear 0.3s, opacity 0.3s 0s, transform 0.3s;
	pointer-events: none;
	width: ${({ $width }) => $width}px;
	z-index: 999;

	&.show {
		opacity: 1;
		visibility: visible;
		transform: scale(1);
		transition: visibility 0s linear 0s, opacity 0.3s 0s, transform 0.3s;
		pointer-events: all;
	}
`;

export const Header = styled.div`
	padding: 10px 14px 6px;
`;

export const OptionContainer = styled.ul`
	display: flex;
	flex-direction: column;
`;

export const Option = styled.li`
	padding: 10px 14px;
	cursor: pointer;
	display: flex;
	align-items: center;

	&:hover {
		background-color: ${({ theme }) => theme.neutralButton};
	}
	p {
		flex-grow: 1;
	}
`;
